import * as CubeTree from '../../cubeTree/index';
import Utils from '../../utils/util';
import FrontCubeData from '../../frontCubeData/index';
import Config from '../../config/index';
import { containSubGoodsSize } from '../goods/goodsSize';

const defaultLayerHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultLayerHeight'
});
const defaultModuleHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultModuleHeight'
});
const firstNormalLayerMinHeight: PhysicsMeasurement = Utils.math(defaultLayerHeight, 2, '*');

function beamBootomIsEmpty(layer: CubeId): PhysicsMeasurement {
    let result: PhysicsMeasurement = 0;
    let currentCubeModuleHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'moduleHeight');
    let currentCubePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'posY');

    if (currentCubeModuleHeight <= 0) {
        currentCubeModuleHeight = defaultModuleHeight;
    }

    result = Utils.math(currentCubeModuleHeight, currentCubePosY, '+');

    return result;
}

function beamBootomIsBeamOrFoof(layer: CubeId, bottomLayer: CubeId): PhysicsMeasurement {
    let result: PhysicsMeasurement = 0;
    let currentCubeModuleHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'moduleHeight');
    let bottomCubeModuleHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(bottomLayer, 'moduleHeight');
    let currentCubePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'posY');
    let bottomCubePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(bottomLayer, 'posY');

    if (currentCubeModuleHeight <= 0) {
        currentCubeModuleHeight = defaultModuleHeight;
    }

    if (bottomCubeModuleHeight <= 0) {
        bottomCubeModuleHeight = defaultModuleHeight;
    }

    let currentTopLine: PhysicsMeasurement = Utils.math(currentCubePosY, currentCubeModuleHeight, '+');
    let bottomLayerTopLine: PhysicsMeasurement = Utils.math(bottomCubePosY, bottomCubeModuleHeight, '+');
    let spaceHeight: PhysicsMeasurement = Utils.math(currentTopLine, bottomLayerTopLine, '-');

    result = spaceHeight;
    return result;
}

function topIsNormalLayer(layer: CubeId): PhysicsMeasurement {
    let result: PhysicsMeasurement = 0;
    let currentCubePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'posY');
    let currentCubeModuleHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'moduleHeight');
    let prevLayerCubeId: CubeId = CubeTree.findPrevCube(layer);
    let prevLayer: CubeNode = CubeTree.findByCubeId(prevLayerCubeId);
    let prevLayerPosY: PhysicsMeasurement = FrontCubeData.getNumberValue(prevLayer.id, 'posY');

    if (currentCubeModuleHeight <= 0) {
        currentCubeModuleHeight = defaultModuleHeight;
    }

    let currentBottomLine: PhysicsMeasurement = Utils.math(currentCubePosY, currentCubeModuleHeight, '+');

    result = Utils.math(prevLayerPosY, currentBottomLine, '-');

    return result;
}

function topLayerIsBeam(layer: CubeId): PhysicsMeasurement {
    let result: PhysicsMeasurement = 0;
    let prevLayerCubeId: CubeId = CubeTree.findPrevCube(layer);
    let prevLayerPosY: PhysicsMeasurement = FrontCubeData.getNumberValue(prevLayerCubeId, 'posY');
    let prevSpaceSize: PhysicsMeasurement = getBeamSpaceSize(prevLayerCubeId);
    let prevLayerModuleHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(prevLayerCubeId, 'moduleHeight');
    let currentCubePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'posY');
    let currentCubeModuleHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'moduleHeight');

    if (currentCubeModuleHeight <= 0) {
        currentCubeModuleHeight = defaultModuleHeight;
    }

    if (prevLayerModuleHeight <= 0) {
        prevLayerModuleHeight = defaultModuleHeight;
    }

    if (prevSpaceSize < prevLayerModuleHeight) {
        prevSpaceSize = prevLayerModuleHeight;
    }

    let prevDropHeight: PhysicsMeasurement = Utils.math(prevSpaceSize, prevLayerModuleHeight, '-');
    let currentBottomLine: PhysicsMeasurement = Utils.math(currentCubePosY, currentCubeModuleHeight, '+');
    let currentTopLine: PhysicsMeasurement = Utils.math(prevLayerPosY, prevDropHeight, '-');

    result = Utils.math(currentTopLine, currentBottomLine, '-');

    return result;
}

// 第1个普通层板的最小层高设置为默认层高2倍
function firstNormalLayer(layer: CubeId): PhysicsMeasurement {
    let result: PhysicsMeasurement = 0;
    let parentCube: CubeNode = CubeTree.findParentCubeByCubeId(layer);
    let parentHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(parentCube.id, 'height');
    let currentCubePosY: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'posY');
    let currentCubeModuleHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(layer, 'moduleHeight');
    let bottomLine: PhysicsMeasurement = Utils.math(parentHeight, currentCubePosY, '-');

    if (currentCubeModuleHeight <= 0) {
        currentCubeModuleHeight = defaultModuleHeight;
    }

    result = Utils.math(bottomLine, currentCubeModuleHeight, '-');
    // if (result < firstNormalLayerMinHeight) {
    //     result = firstNormalLayerMinHeight;
    // }
    return result;
}

function getBeamSpaceSize(layer: CubeId): PhysicsMeasurement {
    let spaceSize: PhysicsMeasurement = defaultLayerHeight;
    let goodsIds: Array<CubeId> = CubeTree.getChildCubeIds(layer);

    for (var i = 0; i < goodsIds.length; i++) {
        let goods: CubeNode = CubeTree.findByCubeId(goodsIds[i]);
        let height: PhysicsMeasurement = containSubGoodsSize(goods).height;

        spaceSize = Math.max(spaceSize, height);
    }

    return spaceSize;
}

export {
    beamBootomIsEmpty,
    beamBootomIsBeamOrFoof,
    getBeamSpaceSize,
    firstNormalLayer,
    topLayerIsBeam,
    topIsNormalLayer
};
